import moment from 'moment';
import DocumentService from '../services/document.service';

const getFileType = (file) => {
  if (file) {
    const index = file.lastIndexOf('.');
    return file.slice(index + 1);
  }
  return file;
};

const groupDocuments = (t, documents) => {
  const groupedDocs = {
    [DocumentService.TODAY]: [],
    [DocumentService.YESTERDAY]: [],
    [DocumentService.LAST_WEEK]: [],
    [DocumentService.LATER]: [],
  };
  documents.forEach((doc) => {
    let diff = moment().diff(doc.created_at, 'days');
    const doubleCheck = moment().isSame(doc.created_at, 'd');
    diff = !diff && !doubleCheck ? 1 : diff;
    if (!diff) {
      groupedDocs[DocumentService.TODAY].push({ ...doc,
        created_at: moment(doc.created_at).format('HH:mm'),
        type: getFileType(doc.original) });
    } else if (diff === 1) {
      groupedDocs[DocumentService.YESTERDAY].push({ ...doc,
        created_at: t('Yesterday'),
        type: getFileType(doc.original) });
    } else if (diff < 7) {
      groupedDocs[DocumentService.LAST_WEEK].push({ ...doc,
        created_at: moment(doc.created_at).format('MMM D, YYYY'),
        type: getFileType(doc.original) });
    } else {
      groupedDocs[DocumentService.LATER].push({ ...doc,
        created_at: moment(doc.created_at).format('MMM D, YYYY'),
        type: getFileType(doc.original) });
    }
  });

  Object.keys(groupedDocs).forEach((item) => {
    if (!groupedDocs[item].length) { delete groupedDocs[item]; }
  });
  return groupedDocs;
};


export default {
  groupDocuments,
  getFileType,
};



// WEBPACK FOOTER //
// ./src/helpers/document.helper.js